<template>
    <div>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      
      <v-card class="box">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title><strong>Self Appraisal Status</strong></v-toolbar-title>
        </v-toolbar>
        
        <v-row class="sub-row" justify="center" dense>
          <v-col cols="12" xs="12" sm="2" lg="2" md="12">
            <p class="padding-bot"><b>Academic Year</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="academicyear"
              :items="aylist"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
            />
          </v-col>
          <v-col cols="12" xs="12" sm="2" lg="2" md="12">
            <p class="padding-bot"><b></b></p><br />
            <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="proceed">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card>
  
      <v-card class="box" v-if="show_table">
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title><strong>Self Appraisal Status</strong></v-toolbar-title>
        </v-toolbar><br />
        
        <v-simple-table class="elevation-1">
          <template>
            <thead class="table-head">
              <tr>
                <th class="text-left table-head">Sr. No.</th>
                <th class="text-left table-head">Parameter</th>
                <th class="text-left table-head">Max Marks</th>
                <th class="text-left table-head">Self Marks</th>
                <th class="text-left table-head">Self Re-Marks</th>
                <th class="text-left table-head">Coordinator Marks</th>
                <th class="text-left table-head">Coordinator Remark</th>
                <th class="text-left table-head">Principal Mark</th>
                <th class="text-left table-head">Principal Remark</th>
              </tr>
            </thead>
            
            <tbody v-for="(item, i) in filtered_data_list" :key="i">
              <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ item.parameter_name }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              <tr v-for="(topic) in item.sublist" :key="topic.approving_Marks_id">
                <td></td>
                <td><span>{{ topic.subparameter_no }}.</span>{{ topic.subparameter_name }}</td>    
                <td>{{ topic.marks }}</td>   
                <td>{{ topic.authorityMarks }}</td>   
                <td>{{ topic.authorityRemarks }}</td> 
                <td>{{ topic.coordinator_Marks }}</td> 
                <td>{{ topic.coordinator_Remarks }}</td> 
                <td>{{ topic.approving_Marks }}</td> 
                <td>{{ topic.approving_Remarks }}</td> 
              </tr>
            </tbody>
  
            <!-- Total Row -->
            <tr v-if="all_data_list.length > 0">
              <td></td>
              <td><b>Total</b></td>
              <td>{{ total_marks }}</td>
              <td>{{ self_total_marks }}</td>
              <td>--</td>
              <td>{{ coordinator_total_marks }}</td>
              <td>--</td>
              <td>{{ principal_total_marks }}</td>
              <td>--</td>
            </tr>
          </template>
        </v-simple-table>
      </v-card>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import "@/assets/css/color.css"; // Import CSS
  
  export default {
    data: () => ({
      loader: false,
      proceed_loader: false,
      snackbar_msg: "",
      snackbar: false,
      color: "",
      aylist: [],
      instructor_list: [],
      instructor: "",
      academicyear: "",
      basepath: "",
      all_data_list: [],
      show_table: false,
      total_marks: "",
      self_total_marks: "",
      coordinator_total_marks: "",
      principal_total_marks: "",
    }),
  
    computed: {
      // Filter out the total object from the data list
      filtered_data_list() {
        return this.all_data_list.filter(item => item.parameter_name);
      }
    },
  
    methods: {       
      proceed() {
        if (!this.academicyear) {
          this.showSnackbar("#b71c1c", "Please Select Academic Year...");
          return;
        }
  
        this.proceed_loader = true;
        this.all_data_list = [];
  
        const formData = { ay: this.academicyear };
  
        axios.post("/FillSelfAppriasal/fetchSelfAppriasalStatus", formData)
          .then(res => {
            if (res.data.flag === "YES") {
              this.proceed_loader = false;
              this.show_table = true;
  
              // Exclude the last object (which contains totals)
              this.all_data_list = res.data.final_List.slice(0, -1);
  
              // Extract total marks from the last object
              const totals = res.data.final_List[res.data.final_List.length - 1];
              this.total_marks = totals.total_marks;
              this.self_total_marks = totals.self_marks;
              this.coordinator_total_marks = totals.coordinator_marks;
              this.principal_total_marks = totals.principal_marks;
            } else if (res.data.flag === "No") {
              this.showSnackbar("#b71c1c", res.data.snackbar);
              this.proceed_loader = false;
              this.show_table = false;
              this.all_data_list = [];
              return;
            } 
  
            if (res.data.final_List.length <= 0) {
              this.showSnackbar("#b71c1c", "Appriasal Data Not Available...");
              this.proceed_loader = false;
              this.show_table = false;
              this.all_data_list = [];
            }
          })
          .catch(error => console.error(error));
      },
  
      onLoad() {
        axios.post("/FillSelfAppriasal/getData")
          .then(res => {
            if (res.data.flag === "YES") {
              this.aylist = res.data.aylist;
              this.basepath = res.data.aws_path;
              this.instructor_list = res.data.instructor_list_approving;
              this.academicyear = res.data.cay;
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong!");
            }
          })
          .catch(error => console.error(error));
      },
  
      showSnackbar(clr, msg) {
        this.snackbar = true;
        this.color = clr;
        this.snackbar_msg = msg;
      }
    },
  
    mounted() {
      this.onLoad();
    }
  };
  </script>
  


<style scoped>
.tc-title {
        background-image: linear-gradient(-90deg, #fff, blue);
        color: #fff;
        border-radius: 3px;
    }

    .table-head {
    background: #0f2027; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    color: white  !important;
    }
    .textcolor{
        color: darkblue;
        font-weight: bold;
    }
      td,
    th {
        border: 1px solid #ccc;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        font-weight: bold;
    }
    td{
        margin: 1rem !important;
        padding: 1rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
sub-row {
        border: 2px solid #424093;
        margin: 1rem;
        border-radius: 5px;
    }

    i {
        font-size: 20px !important;
    }

    .v-card__title {
        border: 1px solid #80808040;
        font-weight: bold;
        background-color: #424093;
        color: white;
        text-align: center;
        /* margin-top: 1.5rem; */
    }
    .card-border {
        border: 2px solid darkblue;
        border-radius: 10px;
        /* padding: 5px; */
        /* margin: 1rem !important; */
        width: auto;
    }

    .tx-bold {
        font-weight: bold;
        font-size: 14px;
        color: black;
    }

    i {
        font-size: 26px;
        cursor: pointer;
    }

    theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background-color: #424093 !important;
        color: white !important;
        margin-top: 2.35rem;
        border-radius: 20px;
    }

    /*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

    @media only screen and (max-width: 600px) {
    }

    .imgs {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: 150px;
        cursor: zoom-in;
    }

    .imgs-preview {
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 5px;
        width: auto;
    }

    v-simple-table {
        border-collapse: collapse;
        border-spacing: 0;
        width: auto;
        border: 1px solid #ddd;
    }

    th {
        color: white;
        font-weight: bold;
        text-align: center !important;
    }

    td,
    th {
        padding: 6px;
        border: 1px solid #ccc;
        text-align: center;
    }
    @media all and (max-width: 900px) {
        .padding-bot {
            padding: 8px;
        }
    }

    @media all and (min-width: 1000px) {
        .padding-metting {
            padding-right: 22px;
        }
    }
    @media (min-width: 320px) and (max-width: 350px) {
        .padding-bot {
            font-size: 11.6px;
        }
    }
    @media (min-width: 1000px) and (max-width: 1050px) {
        .padding-bot {
            font-size: 9.6px;
        }
    }
     .slide {
        color: red;
        font-weight: bold;
        margin-left: 10px;
    }


</style>
